export const WhatsAppColoredIcon = () => (
  <svg
    width="48"
    height="49"
    viewBox="0 0 48 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#a)">
      <path
        d="M23.978 44.085c10.911 0 19.757-8.846 19.757-19.758S34.89 4.57 23.978 4.57 4.22 13.415 4.22 24.327s8.846 19.758 19.758 19.758"
        fill="#2AB540"
      />
      <path
        d="M11.305 24.212c0 2.242.585 4.43 1.699 6.36l-1.806 6.592 6.746-1.77a12.7 12.7 0 0 0 6.082 1.55h.005c7.013 0 12.722-5.708 12.725-12.722a12.64 12.64 0 0 0-3.724-9 12.65 12.65 0 0 0-9.001-3.73c-7.015 0-12.723 5.706-12.726 12.72m4.017 6.028-.252-.4a10.54 10.54 0 0 1-1.617-5.627c.003-5.83 4.747-10.574 10.581-10.574a10.5 10.5 0 0 1 7.478 3.101 10.5 10.5 0 0 1 3.095 7.48c-.002 5.83-4.747 10.575-10.577 10.575h-.004a10.57 10.57 0 0 1-5.383-1.474l-.386-.23-4.004 1.05z"
        fill="#fff"
      />
      <path
        d="M20.85 18.893c-.238-.53-.488-.54-.715-.55-.186-.007-.398-.007-.61-.007s-.556.08-.848.398-1.113 1.088-1.113 2.652 1.14 3.076 1.299 3.288 2.2 3.525 5.431 4.8c2.686 1.059 3.232.848 3.815.795s1.882-.768 2.147-1.511.265-1.379.185-1.512c-.08-.132-.291-.212-.61-.37-.317-.16-1.88-.929-2.172-1.035-.291-.106-.503-.16-.715.16-.212.317-.821 1.033-1.007 1.245s-.37.24-.689.08c-.317-.16-1.342-.495-2.557-1.578-.945-.843-1.583-1.883-1.769-2.202-.185-.317-.02-.49.14-.648.143-.142.318-.372.477-.557s.212-.318.318-.53.053-.398-.027-.557-.697-1.732-.98-2.36"
        fill="#fff"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M4 4.35h40v40H4z" />
      </clipPath>
    </defs>
  </svg>
);

export default WhatsAppColoredIcon;
